module.exports = __webpack_public_path__ + "images/takeover.0afd7f20f9b131c4549264e26fa492df.png";